export const ANSWER_START = 'ANSWER_START';
export const ANSWER_SUCCESS = 'ANSWER_SUCCESS';
export const ANSWER_FAIL = 'ANSWER_FAIL';
export const ANSWER_RESET = 'ANSWER_RESET';
